/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { State } from '@core/store';
import * as DepartmentsActions from '@departments/store/departments.actions';
import { getVehicleDepartments } from '@departments/store/departments.selectors';
import { Store } from '@ngrx/store';
import { Department, LicenseClass, Vehicle } from '@shared/models';
import * as VehicleActions from '@vehicles/store/vehicles.actions';
import { getCurrentVehicle, getIsVehicleActionPending, getLicenseClasses } from '@vehicles/store/vehicles.selectors';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-vehicle-detail',
    templateUrl: './vehicle-detail.component.html',
    styleUrls: ['./vehicle-detail.component.scss'],
    standalone: false
})
export class VehicleDetailComponent implements OnInit {
  vehicle$: Observable<Vehicle>;
  isVehicleLoading$: Observable<boolean>;
  licenseClasses$: Observable<LicenseClass[]>;
  departments$: Observable<Department[]>;
  vehicleForm: UntypedFormGroup;

  constructor(
    private store: Store<State>,
    private formBuilder: UntypedFormBuilder
  ) {
    this.vehicleForm = formBuilder.group({
      licensePlate: ['', Validators.required],
      licenseClass: ['', Validators.required],
      description: [''],
      department: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.store.dispatch(new DepartmentsActions.LoadDepartments());

    this.vehicle$ = this.store.select(getCurrentVehicle).pipe(
      tap(vehicle => this.vehicleForm.patchValue({
        ...vehicle,
        department: vehicle.department ? vehicle.department['@id'] : null
      }))
    );
    this.isVehicleLoading$ = this.store.select(getIsVehicleActionPending);
    this.licenseClasses$ = this.store.select(getLicenseClasses);
    this.departments$ = this.store.select(getVehicleDepartments);
  }

  persistVehicle(): void {
    this.store.dispatch(new VehicleActions.PersistVehicle(this.vehicleForm.value));
  }
}
